export default __webpack_public_path__ + "static/media/TrashCan.bff19143.svg";